/**************************************************************************************************/
/*   File: /src/app/shared/directives/file-upload/file-upload.directive.ts                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * The directive for file upload
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[nwplFrntFileUpload]'
})
export class FileUploadDirective {

  /**
   * The output emitted
   */
  @Output() fileChanges: EventEmitter<any> = new EventEmitter<any>();

  /**
   * The constructor
   */
  constructor() { }

  /**
     * Get notify when files been change from input.
     *
     * @param {*} event
     * @memberof FileUploadDirective
     */
  @HostListener('change', ['$event']) public onFilesChange(event: any) {
    this.fileChanges.emit(event.target.files);
  }

}
